import { useEffect, useState } from 'react';
import Cookie from 'js-cookie';

export default function useSyncUserType(params: { query: any; domain: string }) {
  const { query, domain } = params;
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const userType = query?.userType || 'person';
    Cookie.set('clientUserType', userType, { domain: domain, path: '/' });
    setShowContent(true);
  }, []);

  return {
    showContent,
  };
}
